module.exports = __webpack_public_path__ + "img/12.7eee2a0f.png";